<app-dialog-heading [heading]="'Add New Manufacturer'"></app-dialog-heading>
<div class="dialog-content">
    <form>
        <mat-form-field>
            <mat-label>Manufacturer Name</mat-label>
            <input matInput type="text" [formControl]="manufacturerNameFormControl" required>
        </mat-form-field>
    </form>
    <p style="color: red">{{errorMessage}}</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button (click)="onSaveClick()" color="primary">Save</button>
    <button class="dialog-button" mat-raised-button (click)="onCancelClick()" color="warn" >Cancel</button>
</mat-dialog-actions>
